import { z } from 'zod';

const UICfgAttributeElementCommonOptionsDefault = {
    showTitle: true,
    showDescription: false,
    showDetails: false,
    showDetailsDescription: false,
    showDetailsImage: false,
    showDetailsTitle: true,
    layout: 'card',
};
const UICfgAttributeElementCommonItemOptionsDefault = {
    showTitle: true,
    showDescription: true,
    showImage: false,
};
const UICfgTextAttributeElementItemOptionsDefault = Object.assign({}, UICfgAttributeElementCommonItemOptionsDefault);
const UICfgTextAttributeElementOptionsDefault = Object.assign(Object.assign({}, UICfgAttributeElementCommonOptionsDefault), { layout: 'card', itemOptions: Object.assign({}, UICfgTextAttributeElementItemOptionsDefault) });
const UICfgBooleanAttributeElementItemOptionsDefault = Object.assign({}, UICfgAttributeElementCommonItemOptionsDefault);
const UICfgIntegerAttributeElementItemOptionsDefault = Object.assign({}, UICfgAttributeElementCommonItemOptionsDefault);
const UICfgDecimalAttributeElementItemOptionsDefault = Object.assign({}, UICfgAttributeElementCommonItemOptionsDefault);
const UICfgBooleanAttributeElementOptionsDefault = Object.assign(Object.assign({}, UICfgAttributeElementCommonOptionsDefault), { layout: 'card', itemOptions: Object.assign({}, UICfgBooleanAttributeElementItemOptionsDefault) });
const UICfgIntegerAttributeElementOptionsDefault = Object.assign(Object.assign({}, UICfgAttributeElementCommonOptionsDefault), { layout: 'card', itemOptions: Object.assign({}, UICfgIntegerAttributeElementItemOptionsDefault) });
const UICfgDecimalAttributeElementOptionsDefault = Object.assign(Object.assign({}, UICfgAttributeElementCommonOptionsDefault), { layout: 'card', itemOptions: Object.assign({}, UICfgDecimalAttributeElementItemOptionsDefault) });
const UICfgRalAttributeElementOptionsDefault = Object.assign(Object.assign({}, UICfgAttributeElementCommonOptionsDefault), { layout: 'card', itemOptions: Object.assign({}, UICfgAttributeElementCommonItemOptionsDefault), customColorOptions: {
        showTitle: true,
        showImage: false,
        title: '',
    } });

const UICfgProductsElementOptionsDefault = {
    layout: 'list',
    showDescription: true,
    showImage: false,
    showTitle: true,
};

const UICfgComponentElementOptionsDefault = {
    showDescription: false,
    showForTwoOrMore: false,
    showSwitcher: false,
    showTitle: true,
};

const UICfgComponentContainerElementOptionsDefault = Object.assign(Object.assign({}, UICfgComponentElementOptionsDefault), { defaultForNew: false });
const UICfgProductsContainerElementOptionsDefault = Object.assign(Object.assign({}, UICfgProductsElementOptionsDefault), { mergeProductsFromDifferentComponents: false, defaultForNew: false });
const UICfgAttributesContainerElementOptionsDefault = Object.assign(Object.assign({}, UICfgAttributeElementCommonOptionsDefault), { itemOptions: Object.assign({}, UICfgAttributeElementCommonItemOptionsDefault) });
const UICfgContainerElementDefault = {
    attributesSettings: UICfgAttributesContainerElementOptionsDefault,
    children: [],
    componentsSettings: UICfgComponentContainerElementOptionsDefault,
    productsSettings: UICfgProductsContainerElementOptionsDefault,
    enabled: true,
    isRoot: false,
    id: '',
    kind: 'container',
    name: '',
    type: 'default',
    expandable: false,
    defaultExpanded: false,
};

const traversUIConfigChildren = (item, fn, parents = []) => {
    fn(item, parents);
    if (item.kind === 'container') {
        for (const child of item.children) {
            traversUIConfigChildren(child, fn, [...parents, item]);
        }
    }
};
const findNextContainerId = (root) => {
    let maxId = 0;
    traversUIConfigChildren(root, (item) => {
        if (item.kind === 'container') {
            if (item.name.startsWith('container')) {
                const number = parseInt(item.name.slice('container-'.length));
                if (number >= maxId) {
                    maxId = number;
                }
            }
        }
    });
    return maxId + 1;
};
const findNextItemId = (root, kind, type) => {
    let maxId = 0;
    const prefix = `${kind}-${type ? `${type}-` : ''}`;
    traversUIConfigChildren(root, (item) => {
        if (item.kind === kind) {
            if (item.id.startsWith(prefix)) {
                const number = parseInt(item.id.slice(prefix.length));
                if (number >= maxId) {
                    maxId = number;
                }
            }
        }
    });
    return { id: `${prefix}${maxId + 1}`, idNum: maxId + 1 };
};
const mergeUIConfigSettings = (children, parent, defaultSettings) => {
    const result = {};
    for (const key of Object.keys(defaultSettings)) {
        if (typeof defaultSettings[key] === 'object' && defaultSettings[key] !== null) {
            result[key] = mergeUIConfigSettings(children === null || children === void 0 ? void 0 : children[key], parent === null || parent === void 0 ? void 0 : parent[key], defaultSettings[key]);
        }
        else {
            result[key] =
                children && children[key] !== undefined
                    ? children[key]
                    : parent && parent[key] !== undefined
                        ? parent[key]
                        : defaultSettings[key];
        }
    }
    return result;
};

const makeCatalogVersion = (version) => version;

var ProductVariantFilterTypeDto;
(function (ProductVariantFilterTypeDto) {
    ProductVariantFilterTypeDto["Column"] = "column";
    ProductVariantFilterTypeDto["MetaId"] = "metaId";
    ProductVariantFilterTypeDto["AllDuplicated"] = "all_duplicated";
    ProductVariantFilterTypeDto["Duplicated"] = "duplicated";
    ProductVariantFilterTypeDto["EmptyMetaId"] = "emptyMetaId";
    ProductVariantFilterTypeDto["EmptyCurrencies"] = "emptyCurrencies";
    ProductVariantFilterTypeDto["ZeroPrices"] = "zeroPrices";
})(ProductVariantFilterTypeDto || (ProductVariantFilterTypeDto = {}));
const catalogFiltersTypes = [
    ProductVariantFilterTypeDto.AllDuplicated,
    ProductVariantFilterTypeDto.Duplicated,
    ProductVariantFilterTypeDto.MetaId,
    ProductVariantFilterTypeDto.EmptyMetaId,
    ProductVariantFilterTypeDto.ZeroPrices,
    ProductVariantFilterTypeDto.EmptyCurrencies,
];

const OrganizationRole = {
    OWNER: 'OWNER',
    ADMIN: 'ADMIN',
    USER: 'USER',
};

const isCompositeProductPresetVariantSource = (value) => {
    return ['catalog', 'product', 'inherited', 'generated'].includes(value);
};

var AttributeDbType;
(function (AttributeDbType) {
    AttributeDbType["text"] = "text";
    AttributeDbType["integer"] = "integer";
    AttributeDbType["boolean"] = "boolean";
    AttributeDbType["decimal"] = "decimal";
})(AttributeDbType || (AttributeDbType = {}));

var ProductStatusEnumDto;
(function (ProductStatusEnumDto) {
    ProductStatusEnumDto["New"] = "New";
    ProductStatusEnumDto["Released"] = "Released";
    ProductStatusEnumDto["Updated"] = "Updated";
    ProductStatusEnumDto["Deleted"] = "Deleted";
})(ProductStatusEnumDto || (ProductStatusEnumDto = {}));

const productVariantAttributesSchema = (() => {
    const shape = {};
    for (let i = 1; i <= 30; i += 1) {
        const index = i;
        shape[`text${index}`] = z.string().nullable().optional();
        shape[`integer${index}`] = z.number().int().nullable().optional();
        shape[`decimal${index}`] = z.coerce.number().nullable().optional();
        shape[`boolean${index}`] = z.boolean().nullable().optional();
    }
    return z.object(shape);
})();
const productVariantDescSchema = z.object({
    id: z.number().int(),
    name: z.string().nullable(),
    status: z.nativeEnum(ProductStatusEnumDto),
});
const productVariantDtoSchema = productVariantDescSchema.merge(productVariantAttributesSchema).extend({
    isDefault: z.boolean(),
    isVirtual: z.boolean(),
    deleted: z.boolean(),
});

const makeProductVersion = (version) => version;
const makeProductTypeVersion = (version) => version;

const point3dSchema = z.object({
    x: z.number(),
    y: z.number(),
    z: z.number(),
});
const jointPointVectorsSchema = z.object({
    position: point3dSchema,
    rotation: point3dSchema,
    direction: point3dSchema.optional(),
});
const jointPointDtoSchema = z.object({
    id: z.number().int(),
    key: z.string(),
    name: z.string(),
    jointPoint: jointPointVectorsSchema,
});
const model3dDtoSchema = z.object({
    id: z.number().int(),
    key: z.string(),
    name: z.string(),
    url: z.string(),
    previewUrl: z.string(),
    model3dJointPoints: z.array(jointPointDtoSchema),
});

var ReleaseReason;
(function (ReleaseReason) {
    ReleaseReason["BasicProductRelease"] = "basicProductRelease";
    ReleaseReason["BasicProductTypeRelease"] = "basicProductTypeRelease";
    ReleaseReason["CompositeProductTypeRelease"] = "compositeProductTypeRelease";
    ReleaseReason["CompositeProductRelease"] = "compositeProductRelease";
})(ReleaseReason || (ReleaseReason = {}));

const ProjectRoles = {
    PRODUCT_MANAGER: 'PRODUCT_MANAGER',
    CATALOG_MANAGER: 'CATALOG_MANAGER',
};

const AssetTypes = {
    Folder: 'Folder',
    Model3d: 'Model3d',
    Image: 'Image',
    Material: 'Material',
    Environment: 'Environment',
    Font: 'Font',
    Css: 'Css',
};
const AssetMoveTypes = {
    Replace: 'Replace',
    KeepBoth: 'KeepBoth',
};

export { AssetMoveTypes, AssetTypes, AttributeDbType, OrganizationRole, ProductStatusEnumDto, ProductVariantFilterTypeDto, ProjectRoles, ReleaseReason, UICfgAttributeElementCommonItemOptionsDefault, UICfgAttributeElementCommonOptionsDefault, UICfgAttributesContainerElementOptionsDefault, UICfgBooleanAttributeElementItemOptionsDefault, UICfgBooleanAttributeElementOptionsDefault, UICfgComponentContainerElementOptionsDefault, UICfgComponentElementOptionsDefault, UICfgContainerElementDefault, UICfgDecimalAttributeElementItemOptionsDefault, UICfgDecimalAttributeElementOptionsDefault, UICfgIntegerAttributeElementItemOptionsDefault, UICfgIntegerAttributeElementOptionsDefault, UICfgProductsContainerElementOptionsDefault, UICfgProductsElementOptionsDefault, UICfgRalAttributeElementOptionsDefault, UICfgTextAttributeElementItemOptionsDefault, UICfgTextAttributeElementOptionsDefault, catalogFiltersTypes, findNextContainerId, findNextItemId, isCompositeProductPresetVariantSource, jointPointDtoSchema, makeCatalogVersion, makeProductTypeVersion, makeProductVersion, mergeUIConfigSettings, model3dDtoSchema, productVariantDtoSchema, traversUIConfigChildren };
//# sourceMappingURL=bundle.mjs.map
